<template lang="html">

  <section class="single-game" v-if="game">
    <!--    <div :style="{backgroundImage: `url(${img_url})`}" class="game_image"></div>-->
    <img :src="(game.picture_path.includes('http')) ? game.picture_path : img_url + game.picture_path"
         alt="Bild des Spiels" class="game_image" id="game_image"/>
    <!--    <div class="game_image" id="game_image_container"></div>-->
    <div class="game_gradient"></div>
    <div class="game_container">
      <v-row>
        <v-col cols="4">
          <v-img
              :src="(game.picture_path.includes('http')) ? game.picture_path : img_url + 'thumb_' + game.picture_path"
              alt="Thumbnail des Spiels"
              class="game_thumb img-fluid"/>
        </v-col>
        <v-col cols="8">
          <!--          <v-row>-->
          <!--            <v-col cols="12" class="mt-0 pt-0 game_info">-->
          <!--              <h1 v-if="game.name.de">{{ game.name.de }}</h1>-->
          <h1>{{ game.name.en }}</h1>
          <v-btn small class="mt-2" @click.stop="removeFromWishlist"
                 color="success" v-if="isOnWishlist">
            <v-icon>mdi-check</v-icon>
            Wishlist
          </v-btn>
          <v-btn small class="mt-2" @click.stop="addToWishlist"
                 color="accent" v-else>
            <v-icon>mdi-plus</v-icon>
            Wishlist
          </v-btn>
          <!--            </v-col>-->
          <!--            <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp"></v-col>-->
          <v-col lg="12" md="12" sm="12" xs="12" v-if="$vuetify.breakpoint.mdAndUp">
            <v-rating class="onhover"
                      half-increments hover x-large
                      v-model="user_rating" :readonly="false"
                      :color="'primary'"
                      @input="rate($event, game, false)"
                      style="margin-left: -0.5rem; margin-top: -0.5rem"></v-rating>
            <v-btn small class="mb-5" @click.stop="user ? reviewDialog = true : $router.push('/login')"
                   color="accent">Write
              a review
            </v-btn>
            <br>
            <span>
              <v-icon class="mr-2">mdi-circle-off-outline</v-icon><span
                class="primary_color">{{ game.rating }}</span>  <br>
                  <span v-if="game.playerMax > 0 && game.playerMin !== game.playerMax">
                        <v-icon class="mr-2">mdi-account-multiple</v-icon><span
                      class="primary_color">{{ game.playerMin }}</span> to <span
                      class="primary_color">{{ game.playerMax }}</span> players<br>
                  </span>
                  <span v-else>
                        <v-icon class="mr-2">mdi-account-multiple</v-icon>
                    <span class="primary_color">{{ game.playerMin }}</span> players<br>
                  </span>
                  <span v-if="game.playTimeMax > 0 && game.playTimeMax !== game.playTimeMin">
                        <v-icon class="mr-2">mdi-timelapse</v-icon><span
                      class="primary_color">{{ game.playTimeMin }}</span> to <span
                      class="primary_color">{{ game.playTimeMax }}</span> minutes playing time<br>
                  </span>
                  <span v-else>
                        <v-icon class="mr-2">mdi-timelapse</v-icon>Ca. <span class="primary_color">{{
                      game.playTimeMin
                    }}</span> minutes playing time<br>
                  </span>
                        <v-icon class="mr-2">mdi-human-male-child</v-icon>Age: <span
                            class="primary_color">{{ game.ageMin }}+</span><br>
                        <v-chip class="mt-2 mr-1" small label
                                :to="{ name: 'allGames', params: { type: 'genre', id: genre.id }}" color="accent"
                                v-bind:key="'genre_'+genre.id"
                                v-for="genre in genres">{{ genre.name }}</v-chip><br><br>
                        <i>Year Published: <br>{{ dateParse(game.release) }}</i><br><br>
                        <i>Publishers:</i><br>
                        <span v-bind:key="'publisher_'+publisher.id" v-for="publisher in publishers">
                          <v-chip class="mt-2 mr-1" small label>{{ publisher.name }}</v-chip>
                        </span>
                    </span>
          </v-col>
          <!--          </v-row>-->
          <section style="margin-top: 80px;" v-if="$vuetify.breakpoint.mdAndUp">
            <v-row v-bind:key="rating.id" v-for="rating in ratings">
              <v-card width="100%" class="mb-3" v-if="rating.text">
                <v-card-text>
                  <v-col cols="12" class="review">
                    <v-row>
                      <router-link :to="{ name: 'user', params: { id: rating.user.id }}">
                        <v-col cols="1">
                          <v-avatar size="40" v-if="rating.user && rating.user.picture_path"
                                    class="avatar avatar_small">
                            <img :src="avatar_url + rating.user.picture_path" alt="Profilbild"/>
                          </v-avatar>
                          <v-avatar size="40" v-else-if="rating.user" class="avatar _default_small">
                            <v-icon class="avatar_default_small">mdi-account</v-icon>
                          </v-avatar>
                        </v-col>
                      </router-link>
                      <v-col>
                        <v-row>
                          <router-link :to="{ name: 'user', params: { id: rating.user.id }}">
                            <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
                              <h2>{{ rating.user.name }}</h2>
                            </v-col>
                          </router-link>
                          <v-col cols="12" class="mt-0 pt-0">
                            <v-rating class="ml-0 game_average_rating" v-model="rating.stars"
                                      half-increments readonly dense
                                      small color="white"></v-rating>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <p>
                      {{ rating.text }}
                    </p>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-row>
            <v-row align="center" justify="center"
                   v-if="ratingPagination && ratingPagination.next_page_url">
              <v-btn @click="moreGameRatings" color="accent">More Reviews</v-btn>
            </v-row>
          </section>
        </v-col>
        <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
          <v-row>
            <v-col cols="12">
              <!--              <span v-html="game.description.de" v-if="game.description.de"></span>-->
              <!--              <span v-html="game.description.en"></span><br><br>-->
              <!--              <i>{{ publisher.name }}, {{ dateParse(game.release) }}</i>-->
            </v-col>
            <v-col lg="5" md="5" sm="12" xs="12">
              <v-card align="center" justify="center">
                <v-rating class="onhover"
                          half-increments hover x-large
                          v-model="user_rating" :readonly="false"
                          :color="'primary'"
                          @input="rate($event, game, false)"
                          style="margin-left: -0.5rem; margin-top: -0.5rem"></v-rating>
                <v-btn small class="mb-5" @click.stop="() => {user ? reviewDialog = true : $router.push('/login')}"
                       color="accent">Write a review
                </v-btn>
              </v-card>
              <br>
              <v-card>
                <v-card-text>
                  <v-icon class="mr-2">mdi-circle-off-outline</v-icon>
                  <span
                      class="primary_color">{{ game.rating }}</span><br>
                  <v-icon class="mr-2">mdi-account-multiple</v-icon>
                  <span
                      class="primary_color">{{ game.playerMin }}</span> to <span
                    class="primary_color">{{ game.playerMax }}</span>
                  players<br>
                  <v-icon class="mr-2">mdi-timelapse</v-icon>
                  <span
                      class="primary_color">{{ game.playTimeMin }}</span> to <span
                    class="primary_color">{{ game.playTimeMax }}</span> minutes playing time<br>
                        <v-icon class="mr-2">mdi-human-male-child</v-icon>Age: <span
                      class="primary_color">{{ game.ageMin }}</span>+<br>
                  <v-chip class="mt-2 mr-1" small label
                          :to="{ name: 'allGames', params: { type: 'genre', id: genre.id }}" color="accent"
                          v-bind:key="'genre_'+genre.id" v-for="genre in genres">{{ genre.name }}
                  </v-chip>
                  <br>
                  <div class="mt-5">
                  <i>Year Published: <br>{{ dateParse(game.release) }}</i><br><br>
                  <i>Publishers:</i><br>
                  <span v-bind:key="'publisher_'+publisher.id" v-for="publisher in publishers">
                          <v-chip class="mt-2 mr-1" small label>{{ publisher.name }}</v-chip>
                        </span>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <section style="margin-top: 80px">
            <v-row v-bind:key="rating.id" v-for="rating in ratings">
              <v-card width="100%" class="mb-3" v-if="rating.text">
                <v-card-text>
                  <v-col cols="12" class="review">

                    <v-row>
                      <router-link :to="{ name: 'user', params: { id: rating.user.id }}">
                        <v-col cols="1">
                          <v-avatar size="40" v-if="rating.user && rating.user.picture_path"
                                    class="avatar avatar_small">
                            <img :src="avatar_url + rating.user.picture_path" alt="Profilbild"/>
                          </v-avatar>
                          <v-avatar size="40" v-else-if="rating.user" class="avatar _default_small">
                            <v-icon class="avatar_default_small">mdi-account</v-icon>
                          </v-avatar>
                        </v-col>
                      </router-link>
                      <v-col>
                        <v-row>
                          <router-link :to="{ name: 'user', params: { id: rating.user.id }}">
                            <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
                              <h2>{{ rating.user.name }}</h2>
                            </v-col>
                          </router-link>
                          <v-col cols="12" class="mt-0 pt-0">
                            <v-rating class="ml-0 game_average_rating" v-model="rating.stars"
                                      half-increments readonly dense
                                      small color="white"></v-rating>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <p>
                      {{ rating.text }}
                    </p>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-row>
            <v-row align="center" justify="center"
                   v-if="ratingPagination && ratingPagination.next_page_url" class="mb-3">
              <v-btn @click="moreGameRatings">More Reviews</v-btn>
            </v-row>

          </section>
        </v-col>
        <v-col cols="12">
          <!--          <v-col cols="5" v-if="$vuetify.breakpoint.mdAndUp">-->
          <!--              <span v-html="game.description.de" v-if="game.description.de"></span>-->
          <span v-if="!showMore">
            <span v-html="shortDescription"></span>
            <a @click="toggleDescription" v-if="!showMore">...More</a>
          </span>
          <span v-if="showMore">
          <span v-html="game.description.en" id="longDescription"></span>
            <a @click="toggleDescription"> Less</a>
          </span>
          <!--          </v-col>-->
        </v-col>
      </v-row>
    </div>


    <v-dialog
        v-model="reviewDialog"
        max-width="500"
    >
      <v-card>
        <v-card-title class="headline">Your Review</v-card-title>


        <v-card-text>
          <v-rating class="onhover"
                    half-increments hover x-large
                    v-model="user_rating" :readonly="false"
                    :color="'primary'"
                    @input="rate($event, game, false)"
                    style="margin-left: -0.5rem; margin-top: -0.5rem"></v-rating>
          <v-textarea no-resize outlined v-model="ratingText"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="reviewDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
              color="green darken-1"
              text
              @click="rate(user_rating, game, true)"
          >
            Create Review
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert dismissible dense type="error" class="error" width="93%" :value="error" transition="scale-transition">
      {{ errorMessage }}
    </v-alert>
  </section>

</template>

<script lang="js">
import GameService from "../../services/GameService";
import UserService from "../../services/UserService";
import GameListService from "../../services/GameListService";
import axios from "axios";
import authHeader from "../../services/auth-header";

export default {
  name:  'single-game',
  props: ['user'],
  mounted () {

  },
  updated () {
    this.$nextTick(function () {
      //this.poly();
    })
  },
  created () {
    this.slug = this.$route.params.slug;
    this.getGameBySlug();
  },
  data () {
    return {
      'slug':             "",
      'game':             null,
      'genres':           null,
      'publishers':       null,
      'img_url':          window.api_url + "/storage/image/game/",
      'user_rating':      0,
      'ratingPagination': null,
      'ratings':          [],
      'reviewDialog':     false,
      'ratingText':       "",
      'avatar_url':       window.api_url + "/storage/image/user/",
      'error':            false,
      'errorMessage':     "",
      'isOnWishlist':     false,
      'showMore':         false,
    }
  },
  computed: {
    shortDescription () {
      return this.game.description.en.substring(0, 1000);
    }
  },
  methods:  {
    toggleDescription () {
      this.showMore = !this.showMore;
    },
    getGameBySlug () {
      GameService.getGameBySlug(this.slug)
                 .then(
                     res => {
                       console.log(res);
                       this.game       = res.data.game;
                       this.genres     = res.data.genres;
                       this.publishers = res.data.publishers;
                       this.getRating(this.game.id);
                       this.getGameRatings();
                       this.onWishlist();
                     }
                 )
                 .catch(err => console.log(err)
                 );
    },
    getRating (id) {
      UserService.getRating(id)
                 .then(res => {
                   if (!isNaN(res.data.stars)) {
                     this.user_rating = parseFloat(res.data.stars);
                     this.ratingText  = res.data.text;
                   }
                 })
                 .catch(err => console.log(err));
    },
    getGameRatings () {
      UserService.getGameRatings(this.game.id)
                 .then(res => {
                   this.ratingPagination = res.data;
                   this.ratings          = res.data.data;
                 })
                 .catch(err => console.log(err));
    },
    moreGameRatings () {
      axios.get(this.ratingPagination.next_page_url, {headers: authHeader()})
           .then(res => {
             res.data.data.forEach(rating => {
               this.ratings.push(rating);
             });
             this.ratingPagination = res.data;
             console.log(this.ratings);
           })
           .catch(err => console.log(err));
    },
    dateParse (date) {
      let formatDate = date.split('-');
      return formatDate[0];
    },
    rate (value, game, dialog) {
      if (this.user) {
        if (!this.user_rating && !isNaN(this.user_rating)) {
          this.error        = true;
          this.errorMessage = "Bitte bewerte das Spiel zunächst"
        } else {
          this.error = false;

          GameService.rate(game.id, value, this.ratingText)
                     .then(res => {
                       game.rating = res.data.average;
                       if (dialog) {
                         this.reviewDialog = false;
                       }
                       this.user_rating = value;
                       this.getGameRatings();
                     })
                     .catch(() => {

                     });
        }
      } else {
        this.$router.push('/login');
      }
    },
    addToWishlist () {
      if (this.user) {
        GameListService.addGameToWishList(this.game.id).then(() => {
          this.isOnWishlist = true;
        });
      } else {
        this.$router.push('/login');
      }
    },
    removeFromWishlist () {
      GameListService.removeGameFromWishList(this.game.id).then(() => {
        this.isOnWishlist = false;
      });
    },
    onWishlist () {
      GameListService.onWishlist(this.game.id).then(res => {
        console.log(res.data);
        this.isOnWishlist = res.data;
      });
    }
  },
}

</script>

<style lang="scss">


.game_image {
  height: 350px;
  object-fit: cover;
  width: 100% !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  z-index: 1;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
  filter: blur(50px);
}

.game_gradient {
  position: absolute;
  width: 100%;
  height: 450px;
  left: 0;
  top: 0;
  z-index: 2;
}

.game_thumb {
  border-radius: 5px;
  border: 1px;
}

.game_info {
  position: relative;
}

.game_container {
  position: relative;
  margin-top: 250px;
  z-index: 3;
}

.game_info_bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 0 0 12px 12px;
}

.review {
}

.error {
  position: fixed;
  bottom: 0;
  z-index: 999;
}
</style>
